import type { IconData } from '@stacksjs/iconify-core'

export const circleAndSquareShape: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M33.645 11C30.758 6.206 25.503 3 19.5 3C10.387 3 3 10.387 3 19.5c0 6.004 3.206 11.258 8 14.145\"/><path d=\"M20.7 44.706c-2.417-.172-4.234-1.99-4.406-4.406c-.156-2.185-.294-5.371-.294-9.8s.138-7.615.294-9.8c.172-2.417 1.99-4.234 4.406-4.406c2.185-.156 5.371-.294 9.8-.294s7.615.138 9.8.294c2.417.172 4.234 1.99 4.406 4.406c.156 2.185.294 5.371.294 9.8s-.138 7.615-.294 9.8c-.172 2.417-1.99 4.234-4.406 4.406c-2.185.156-5.371.294-9.8.294s-7.615-.138-9.8-.294\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default circleAndSquareShape
